import { OperationsData } from 'data/types/operations';

export const normalizeOperations = (data: OperationsData) => {
  return data;
};

export type Operations = ReturnType<typeof normalizeOperations>;
